import React, { useContext, useEffect, useState } from 'react'
import { PeFilterContext } from '../../Contexts/PeFilterContext'
import Popup from '../Common/Popup';

/**
 * The `ExcludeDefunctFilter` function is a React component that renders a checkbox input and label for
 * excluding defunct companies.
 * @returns a JSX element.
 */
function ExcludeDefunctFilter({ isExclude, setisExclude, customPathname, isPopupOpen, setIsPopupOpen }) {
    const { refineSearchFilters } = useContext(PeFilterContext);
    const [internalPopupOpen, setInternalPopupOpen] = useState(false);
    
    // Use centralized state if provided, otherwise fall back to internal state
    const popupOpen = isPopupOpen !== undefined ? isPopupOpen : internalPopupOpen;
    const setPopupOpen = setIsPopupOpen !== undefined ? setIsPopupOpen : setInternalPopupOpen;

    useEffect(() => {
        setisExclude(refineSearchFilters[customPathname]?.excludeDefunctCos?.at(0)?.value ?? false)
    }, [customPathname, refineSearchFilters, setisExclude])


    const onChange = (e) => {
        setisExclude(e.target.checked);
    }

    return (
        <div className="relative w-full md:inline-block">
            <button
                type="button"
                className="h-10 rounded-lg px-4 py-1 text-gray-500 hover:bg-gray-100 text-sm shadow-md border border-gray-300 w-full md:w-[90%] text-left flex items-center justify-between"
                onClick={() => setPopupOpen(!popupOpen)}
            >
                <span className="truncate pr-2">Exclude Defunct Cos</span>
                <div className="flex items-center gap-2 flex-shrink-0">
                    {isExclude && (
                        <span className="bg-white rounded-full px-2 py-0.5 text-xs font-medium border border-gray-400">
                            Yes
                        </span>
                    )}
                    <span className={`transition-transform duration-200 text-xl font-semibold ${popupOpen ? 'rotate-[270deg]' : 'rotate-90'}`}>
                        ›
                    </span>
                </div>
            </button>

            {popupOpen && (
                <Popup onClose={() => setPopupOpen(false)}>
                    <div className="p-4">
                        {/* <label className="block text-sm font-medium text-gray-700 mb-2">
                            Exclude Defunct Companies
                        </label> */}
                        <div className="flex items-center">
                            <input 
                                id='ExcludeDefunctFilter' 
                                type="checkbox" 
                                onChange={onChange}
                                className="cursor-pointer mr-3 h-4 w-4"
                                checked={isExclude} 
                            />
                            <label htmlFor='ExcludeDefunctFilter' className="text-sm cursor-pointer">
                                Exclude Defunct Companies
                            </label>
                        </div>
                    </div>
                </Popup>
            )}
        </div>
    )
}

export default ExcludeDefunctFilter